import { Tab } from "@dashboard/library";
import styled, { getColor } from "@xstyled/styled-components";

export const StyledTabContainer = styled(Tab.Container)`
  flex-direction: row;
  gap: s;

  & > div {
    padding: 0;
  }
`;

export const StyledTabMenuItem = styled(Tab.MenuItem)<{
  disabled: boolean;
}>`
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  color: ${({ disabled }) =>
    disabled ? getColor("text-disabled") : getColor("text-base")};
`;
